// extracted by mini-css-extract-plugin
export default {"button":"CreditTermRateButton_button__twosW"};